export default [
  {
    path: '/gestion_forecast/mantenedor_f/Cultivo',
    name: 'cultivoforere',
    component: () => import('@/views/gestion_forecast/forecast/cultivo.vue'),
    meta: {
      pageTitle: 'Cultivo de Forecast',
      breadcrumb: [
        {
          text: 'Cultivo',
        },
        {
          text: 'Cultivo de Forecast',
          active: true,
        },
      ],
      resource: 'Cultivo Fore Re',
      action: 'menu',
    },
  },
  {
    path: '/gestion_forecast/mantenedor_f/forecast_year',
    name: 'forecastyearre',
    component: () => import('@/views/gestion_forecast/forecast/forecast_year.vue'),
    meta: {
      pageTitle: 'Forecast Year',
      breadcrumb: [
        {
          text: 'Forecast Year',
        },
        {
          text: 'Forecast Year',
          active: true,
        },
      ],
      resource: 'Forecast year Re',
      action: 'menu',
    },
  },
  {
    path: '/gestion_forecast/mantenedor_f/tipo',
    name: 'tipore',
    component: () => import('@/views/gestion_forecast/forecast/tipo.vue'),
    meta: {
      pageTitle: 'Tipos de Forecast',
      breadcrumb: [
        {
          text: 'Tipo',
        },
        {
          text: 'Tipos de Forecast',
          active: true,
        },
      ],
      resource: 'Tipo Re',
      action: 'menu',
    },
  },
  {
    path: '/gestion_forecast/mantenedor_f/version',
    name: 'versionre',
    component: () => import('@/views/gestion_forecast/forecast/version.vue'),
    meta: {
      pageTitle: 'Versiones de Forecast',
      breadcrumb: [
        {
          text: 'Versión',
        },
        {
          text: 'Versiones de Forecast',
          active: true,
        },
      ],
      resource: 'Version Re',
      action: 'menu',
    },
  },
  {
    path: '/gestion_forecast/forecast/fecha',
    name: 'fechare',
    component: () => import('@/views/gestion_forecast/forecast/fecha.vue'),
    meta: {
      pageTitle: 'Listar Fechas',
      breadcrumb: [
        {
          text: 'Fecha',
        },
        {
          text: 'Listar Fechas',
          active: true,
        },
      ],
      resource: 'Fecha Re',
      action: 'menu',
    },
  },
  {
    path: '/gestion_forecast/forecast/Forecasting',
    name: 'forecastingre',
    component: () => import('@/views/gestion_forecast/forecast/forecasting.vue'),
    meta: {
      pageTitle: 'Listar Forecasting',
      breadcrumb: [
        {
          text: 'Forecasting',
        },
        {
          text: 'Listar Forecasting',
          active: true,
        },
      ],
      resource: 'Forecasting Re',
      action: 'menu',
    },
  },

]
